import * as React from 'react';
import { Events } from '@type-r/models';
import { EditRelationship } from './details/index';
import { RelationshipsLandingPage } from './relationships-list';

// Relationship management page
export const RelationshipsPage = () => {
    const relationshipId = getRelationshipId();
    
    return (
        !relationshipId || relationshipId == 'all' ?
            <RelationshipsLandingPage />
        :
            <EditRelationship
                relationshipId={relationshipId}
            />
    )
}

function getRelationshipId(){    
    const path = window.location.pathname.split( '/' );
    return path.length === 3 ? path[ 2 ] : null;
}

function back(){
    Events.trigger( 'navigate', window.location.pathname.split( '/' ).slice( 0, 2 ).join('/') );
}
